/* Display-only title + vendor. Never writes catalog.
   Covers USF-injected cards and any leftover warehouse strings. */
(function () {
  var GENDER = { MENS:1, MEN:1, WOMENS:1, WOMEN:1, KIDS:1, UNISEX:1, BOYS:1, GIRLS:1, YOUTH:1, MALE:1, FEMALE:1 };
  var COLORS = { BLACK:1, WHITE:1, GREY:1, GRAY:1, CREAM:1, TAUPE:1, NAVY:1, BROWN:1, RED:1, BLUE:1, GREEN:1, PINK:1, PURPLE:1, ORANGE:1, YELLOW:1, BEIGE:1, IVORY:1, BONE:1, SAND:1, OLIVE:1, KHAKI:1, SILVER:1, GOLD:1, CORE:1, PHANTOM:1, SAIL:1, MOCHA:1, OREO:1, GUM:1 };
  var PAIR = { ALL:1, TRIPLE:1 };
  var ALIAS = {
    HOKA: ['HOKA', 'ONE'],
    'HOKA ONE ONE': ['HOKA', 'ONE'],
    'NEW BALANCE': ['NEW', 'BALANCE'],
    ON: ['ON', 'RUNNING'],
    'ON RUNNING': ['ON', 'RUNNING'],
    BIRKENSTOCK: ['BIRKENSTOCK'],
    NIKE: ['NIKE'],
    'AIR JORDAN': ['AIR', 'JORDAN'],
    JORDAN: ['AIR', 'JORDAN'],
    ADIDAS: ['ADIDAS'],
    ASICS: ['ASICS'],
    BROOKS: ['BROOKS'],
    PUMA: ['PUMA'],
    SAUCONY: ['SAUCONY'],
    REEBOK: ['REEBOK'],
    CONVERSE: ['CONVERSE'],
    VANS: ['VANS'],
    UGG: ['UGG'],
    CROCS: ['CROCS'],
    TIMBERLAND: ['TIMBERLAND']
  };
  var HOUSE = {
    'ON RUNNING': 'On',
    ON: 'On',
    HOKA: 'Hoka',
    'HOKA ONE ONE': 'Hoka',
    'NEW BALANCE': 'New Balance',
    'AIR JORDAN': 'Jordan',
    NIKE: 'Nike',
    BIRKENSTOCK: 'Birkenstock',
    ADIDAS: 'Adidas',
    ASICS: 'Asics',
    BROOKS: 'Brooks'
  };

  function key(tok) {
    return String(tok || '').toUpperCase().replace(/['’(),]/g, '').trim();
  }
  function hasDigit(s) { return /\d/.test(s); }
  function vendorSkip(vendor) {
    var v = key(vendor);
    if (ALIAS[v]) return ALIAS[v].reduce(function (o, w) { o[w] = 1; return o; }, {});
    return v.split(/\s+/).reduce(function (o, w) { if (w) o[w] = 1; return o; }, {});
  }
  function isStyle(tok) {
    var k = key(tok);
    if (!k) return true;
    var digit = hasDigit(k);
    var startsLetter = /^[A-Z]/.test(k);
    if (k.indexOf('-') !== -1 && digit && k.length >= 6) return true;
    if (digit && startsLetter && k.length >= 7) return true;
    if (digit && k.length >= 9) return true;
    return false;
  }
  function displayTitle(raw, vendor) {
    if (raw && raw.indexOf(' / ') !== -1) return raw;  // already normalized in catalog data
    if (!raw) return raw;
    var work = String(raw).replace(/\|/g, ' | ').replace(/[–—]/g, ' - ').replace(/\s+/g, ' ').trim();
    work = work.replace(/\s*\((UNISEX|MEN|WOMEN|MENS|WOMENS|KIDS)\)\s*$/i, '').trim();
    var skipV = vendorSkip(vendor);
    var tokens = work.split(' ');
    var kept = [];
    var prefix = true;
    for (var i = 0; i < tokens.length; i++) {
      var tok = tokens[i];
      var k = key(tok);
      if (!k || GENDER[k]) continue;
      if (prefix && skipV[k]) continue;
      if (isStyle(tok)) continue;
      prefix = false;
      kept.push(tok);
    }
    if (!kept.length) return raw;
    var dash = kept.lastIndexOf('-');
    if (dash > 0 && dash < kept.length - 1) {
      return kept.slice(0, dash).join(' ') + ' / ' + kept.slice(dash + 1).join(' ');
    }
    var pipe = kept.indexOf('|');
    if (pipe !== -1) {
      var start = pipe > 0 && COLORS[key(kept[pipe - 1])] ? pipe - 1 : pipe;
      if (start > 0) return kept.slice(0, start).join(' ') + ' / ' + kept.slice(start).join(' ');
    }
    if (kept.length >= 3) {
      var lastK = key(kept[kept.length - 1]);
      var secondK = key(kept[kept.length - 2]);
      if (COLORS[lastK] && PAIR[secondK]) {
        return kept.slice(0, -2).join(' ') + ' / ' + kept.slice(-2).join(' ');
      }
      if (COLORS[lastK] && COLORS[secondK]) {
        return kept.slice(0, -2).join(' ') + ' / ' + kept.slice(-2).join(' ');
      }
      if (COLORS[lastK] && hasDigit(secondK) && secondK.length <= 5) {
        return kept.slice(0, -1).join(' ') + ' / ' + kept[kept.length - 1];
      }
    }
    if (kept.length === 2 && COLORS[key(kept[1])] && hasDigit(key(kept[0]))) {
      return kept[0] + ' / ' + kept[1];
    }
    if (kept.length >= 3 && hasDigit(key(kept[0])) && key(kept[0]).length <= 5) {
      return kept[0] + ' / ' + kept.slice(1).join(' ');
    }
    return kept.join(' ');
  }
  function houseVendor(v) {
    if (!v) return v;
    return HOUSE[key(v)] || v;
  }

  function applyEl(el, vendorHint) {
    if (!el || el.getAttribute('data-qb-done') === '1') return;
    var raw = el.getAttribute('data-qb-raw') || el.textContent;
    var vendor = el.getAttribute('data-qb-vendor') || vendorHint || '';
    if (!vendor) {
      var card = el.closest('.product-block, .usf-sr-product, .usf-product, product-block');
      if (card) {
        var vendEl = card.querySelector('.vendor, .usf-vendor, .product-block__vendor');
        if (vendEl) vendor = vendEl.getAttribute('data-qb-raw') || vendEl.textContent;
      }
    }
    var next = displayTitle(raw.trim(), vendor.trim());
    if (next && next !== el.textContent.trim()) el.textContent = next;
    el.setAttribute('data-qb-done', '1');
  }

  function applyVendor(el) {
    if (!el || el.getAttribute('data-qb-done') === '1') return;
    var raw = el.getAttribute('data-qb-raw') || el.textContent;
    var next = houseVendor(raw.trim());
    if (next && next !== el.textContent.trim()) el.textContent = next;
    el.setAttribute('data-qb-done', '1');
  }

  function run(root) {
    root = root || document;
    root.querySelectorAll('.product-block__title, h1.product-title, .usf-title, .usf-preview__title').forEach(function (el) {
      applyEl(el);
    });
    root.querySelectorAll('.product-block .vendor, .product-block__vendor, .usf-vendor, .usf-preview__vendor, .template-product .vendor a').forEach(function (el) {
      applyVendor(el);
    });
  }

  function boot() {
    run();
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].target;
        if (n && n.nodeType === 1) run(n);
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
